export enum NotificationActionType {
  // asset actions
  DRAFT_ASSET = 'draft_asset',
  PUBLISHED_ASSET = 'published_asset',
  UPDATED_ASSET = 'updated_asset',
  DELETED_ASSET = 'deleted_asset',
  ARCHIVED_ASSET = 'archived_asset',
  ADDED_COLLABORATOR = 'added_collaborator',
  REMOVED_COLLABORATOR = 'removed_collaborator',
  SUBMITTED_REPORT = 'submitted_report',
  // New user unit action types
  ADDED_TO_UNIT = 'added_to_unit',
  REMOVED_FROM_UNIT = 'removed_from_unit',
  ROLE_CHANGED_IN_UNIT = 'role_changed_in_unit',
  // Batch actions
  BATCH_CREATED = 'batch_create',
  BATCH_ERROR = 'batch_error',
  BATCH_COMPLETED = 'batch_completed',
  BATCH_DELETED = 'batch_deleted',
  // Legacy types for backward compatibility
  ERROR_ALERT = 'error_alert',
  URL_CHECK_ALERT = 'url_check_alert'
}
